import { api } from './api';
import { YoutubePlaylist, YoutubePlaylistQuery } from '../types';

const API = Object.freeze({
  root: '/youtube-playlists',
  byId: '/youtube-playlists/{id}',
  enabled: '/youtube-playlists/{id}/enabled',
});

const buildListParams = (query?: YoutubePlaylistQuery) => {
  const params = new URLSearchParams();
  if (!query) return params;

  const trimmedSearch = query.search?.trim();
  if (trimmedSearch) params.set('search', trimmedSearch);

  if (typeof query.enabled === 'boolean') {
    params.set('enabled', String(query.enabled));
  }

  if (typeof query.churchId === 'string') {
    const trimmedChurchId = query.churchId.trim();
    if (trimmedChurchId) params.set('churchId', trimmedChurchId);
  }

  return params;
};

export type YoutubePlaylistUpsertPayload = {
  playlistUrl?: string;
  playlistId?: string;
  displayName?: string | null;
  enabled?: boolean;
  sortOrder?: number;
  churchId?: string | null;
};

export const getYoutubePlaylists = async (query?: YoutubePlaylistQuery) => {
  const params = buildListParams(query);
  const res = await api.get<YoutubePlaylist[]>(API.root, { params });
  return res.data;
};

export const getYoutubePlaylist = async (id: number | string) => {
  const res = await api.get<YoutubePlaylist>(API.byId.replace('{id}', String(id)));
  return res.data;
};

export const createYoutubePlaylist = async (payload: YoutubePlaylistUpsertPayload) => {
  const res = await api.post<YoutubePlaylist>(API.root, payload);
  return res.data;
};

export const updateYoutubePlaylist = async (id: number | string, payload: YoutubePlaylistUpsertPayload) => {
  const res = await api.put<YoutubePlaylist>(API.byId.replace('{id}', String(id)), payload);
  return res.data;
};

export const setYoutubePlaylistEnabled = async (id: number | string, enabled: boolean) => {
  const res = await api.patch<YoutubePlaylist>(API.enabled.replace('{id}', String(id)), { enabled });
  return res.data;
};

export const deleteYoutubePlaylist = async (id: number | string) => {
  const res = await api.delete(API.byId.replace('{id}', String(id)), {});
  return res.data;
};
